module.exports = function (modules) {
  var installedModules = {};
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }
  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js": function __node_modules_Babel_runtimeCorejs3_coreJs_instance_indexOfJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/instance/index-of");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function __node_modules_Babel_runtimeCorejs3_coreJs_object_definePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js": function __node_modules_Babel_runtimeCorejs3_coreJs_object_getOwnPropertySymbolsJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/get-own-property-symbols");
  },
  "../../node_modules/@babel/runtime-corejs3/core-js/object/keys.js": function __node_modules_Babel_runtimeCorejs3_coreJs_object_keysJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/keys");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function __node_modules_Babel_runtimeCorejs3_helpers_classCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js": function __node_modules_Babel_runtimeCorejs3_helpers_definePropertyJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");
    module.exports = function (obj, key, value) {
      return key in obj ? _Object$defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : obj[key] = value, obj;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutProperties.js": function __node_modules_Babel_runtimeCorejs3_helpers_objectWithoutPropertiesJs(module, exports, __webpack_require__) {
    var _indexOfInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js"),
      _Object$getOwnPropertySymbols = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js"),
      objectWithoutPropertiesLoose = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose.js");
    module.exports = function (source, excluded) {
      if (null == source) return {};
      var key,
        i,
        target = objectWithoutPropertiesLoose(source, excluded);
      if (_Object$getOwnPropertySymbols) {
        var sourceSymbolKeys = _Object$getOwnPropertySymbols(source);
        for (i = 0; i < sourceSymbolKeys.length; i++) key = sourceSymbolKeys[i], _indexOfInstanceProperty(excluded).call(excluded, key) >= 0 || Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
      }
      return target;
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose.js": function __node_modules_Babel_runtimeCorejs3_helpers_objectWithoutPropertiesLooseJs(module, exports, __webpack_require__) {
    var _indexOfInstanceProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/instance/index-of.js"),
      _Object$keys = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/keys.js");
    module.exports = function (source, excluded) {
      if (null == source) return {};
      var key,
        i,
        target = {},
        sourceKeys = _Object$keys(source);
      for (i = 0; i < sourceKeys.length; i++) key = sourceKeys[i], _indexOfInstanceProperty(excluded).call(excluded, key) >= 0 || (target[key] = source[key]);
      return target;
    };
  },
  "../../node_modules/webpack/buildin/global.js": function __node_modules_webpack_buildin_globalJs(module, exports) {
    var g;
    g = function () {
      return this;
    }();
    try {
      g = g || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (g = window);
    }
    module.exports = g;
  },
  "./EventProvider.js": function _EventProviderJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    (function (global) {
      __webpack_require__.d(__webpack_exports__, "a", function () {
        return EventProvider;
      }), __webpack_require__.d(__webpack_exports__, "c", function () {
        return subscribe;
      }), __webpack_require__.d(__webpack_exports__, "d", function () {
        return unsubscribe;
      }), __webpack_require__.d(__webpack_exports__, "e", function () {
        return unsubscribeAll;
      }), __webpack_require__.d(__webpack_exports__, "b", function () {
        return publish;
      });
      var _context,
        _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"),
        _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_0__),
        _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/index-of"),
        _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_1__),
        _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/symbol/for"),
        _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2__),
        _babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
        _babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__),
        _babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js"),
        _babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(_babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__),
        _babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/values"),
        _babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_5___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_5__),
        _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/map"),
        _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_6___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_6__),
        _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/every"),
        _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_7___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_7__),
        events__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("events"),
        events__WEBPACK_IMPORTED_MODULE_8___default = __webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_8__),
        lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("lodash"),
        lodash__WEBPACK_IMPORTED_MODULE_9___default = __webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__),
        _jutro_logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("@jutro/logger");
      function mapTopics(topics, callback) {
        return lodash__WEBPACK_IMPORTED_MODULE_9___default.a.isString(topics) ? callback(topics) : lodash__WEBPACK_IMPORTED_MODULE_9___default.a.isArray(topics) && _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_7___default()(lodash__WEBPACK_IMPORTED_MODULE_9___default.a).call(lodash__WEBPACK_IMPORTED_MODULE_9___default.a, topics, lodash__WEBPACK_IMPORTED_MODULE_9___default.a.isString) ? _babel_runtime_corejs3_core_js_stable_instance_map__WEBPACK_IMPORTED_MODULE_6___default()(topics).call(topics, callback) : lodash__WEBPACK_IMPORTED_MODULE_9___default.a.isObject(topics) && _babel_runtime_corejs3_core_js_stable_instance_every__WEBPACK_IMPORTED_MODULE_7___default()(lodash__WEBPACK_IMPORTED_MODULE_9___default.a).call(lodash__WEBPACK_IMPORTED_MODULE_9___default.a, _babel_runtime_corejs3_core_js_stable_instance_values__WEBPACK_IMPORTED_MODULE_5___default()(lodash__WEBPACK_IMPORTED_MODULE_9___default.a).call(lodash__WEBPACK_IMPORTED_MODULE_9___default.a, topics), lodash__WEBPACK_IMPORTED_MODULE_9___default.a.isString) ? lodash__WEBPACK_IMPORTED_MODULE_9___default.a.mapValues(lodash__WEBPACK_IMPORTED_MODULE_9___default.a.mapKeys(topics, function (val) {
          return val;
        }), callback) : void _jutro_logger__WEBPACK_IMPORTED_MODULE_10__.log.error("'subscribe'/'unsubscribeAll' supports only topics defined as:\n    - single string 'topic'\n    - array of strings ['topic1', 'topic2']\n    - object which values are strings {topic1: 'topic1', topic2: 'topic2'}");
      }
      var EventProvider = function EventProvider() {
        var _this = this;
        _babel_runtime_corejs3_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, EventProvider), _babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(this, "publish", function (topic, event) {
          _this.emitter.emit(topic, event);
        }), _babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(this, "subscribe", function (topics, handler) {
          return mapTopics(topics, function (topic) {
            var listener = function listener(event) {
              return handler(event, topic);
            };
            return _this.emitter.on(topic, listener), function () {
              return {
                topic: topic,
                listener: listener
              };
            };
          });
        }), _babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(this, "unsubscribe", function (handle) {
          if (!lodash__WEBPACK_IMPORTED_MODULE_9___default.a.isFunction(handle)) return void _jutro_logger__WEBPACK_IMPORTED_MODULE_10__.log.error("'unsubscribe' supports handles returned by 'subscribe' function.");
          var _handle = handle(),
            listener = _handle.listener,
            topic = _handle.topic;
          _this.emitter.removeListener(topic, listener);
        }), _babel_runtime_corejs3_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(this, "unsubscribeAll", function (topics) {
          lodash__WEBPACK_IMPORTED_MODULE_9___default.a.isUndefined(topics) ? _this.emitter.removeAllListeners() : mapTopics(topics, function (topic) {
            _this.emitter.removeAllListeners(topic);
          });
        }), this.emitter = new events__WEBPACK_IMPORTED_MODULE_8___default.a.EventEmitter(), this.emitter.setMaxListeners(1 / 0);
      };
      var EVENT_PROVIDER_KEY = _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2___default()("jutro.eventProvider");
      -1 === _babel_runtime_corejs3_core_js_stable_instance_index_of__WEBPACK_IMPORTED_MODULE_1___default()(_context = _babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__WEBPACK_IMPORTED_MODULE_0___default()(global)).call(_context, EVENT_PROVIDER_KEY) && (global[EVENT_PROVIDER_KEY] = new EventProvider());
      var eventProvider = global[EVENT_PROVIDER_KEY],
        subscribe = eventProvider.subscribe,
        unsubscribe = eventProvider.unsubscribe,
        unsubscribeAll = eventProvider.unsubscribeAll,
        publish = eventProvider.publish;
    }).call(this, __webpack_require__("../../node_modules/webpack/buildin/global.js"));
  },
  "./index.js": function _indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "ecommerce", function () {
      return ecommerce;
    }), __webpack_require__.d(__webpack_exports__, "ECOMMERCE_TOPICS", function () {
      return ecommerceTopics;
    }), __webpack_require__.d(__webpack_exports__, "initializeEnhancedEcommerce", function () {
      return initializeEnhancedEcommerce;
    }), __webpack_require__.d(__webpack_exports__, "publish", function () {
      return EventProvider.b;
    }), __webpack_require__.d(__webpack_exports__, "subscribe", function () {
      return EventProvider.c;
    }), __webpack_require__.d(__webpack_exports__, "unsubscribe", function () {
      return EventProvider.d;
    }), __webpack_require__.d(__webpack_exports__, "unsubscribeAll", function () {
      return EventProvider.e;
    }), __webpack_require__.d(__webpack_exports__, "EventProvider", function () {
      return EventProvider.a;
    }), __webpack_require__.d(__webpack_exports__, "JUTRO_TOPICS", function () {
      return jutroTopics;
    }), __webpack_require__.d(__webpack_exports__, "loadGA", function () {
      return loadGA;
    }), __webpack_require__.d(__webpack_exports__, "loadMixpanel", function () {
      return loadMixpanel;
    }), __webpack_require__.d(__webpack_exports__, "loadSumoLogic", function () {
      return loadSumoLogic;
    }), __webpack_require__.d(__webpack_exports__, "DefaultDictionaryProvider", function () {
      return DictionaryProvider;
    }), __webpack_require__.d(__webpack_exports__, "DefaultWhitelistProvider", function () {
      return WhitelistProvider;
    }), __webpack_require__.d(__webpack_exports__, "initDefaultGA", function () {
      return defaultimplementation_ga;
    }), __webpack_require__.d(__webpack_exports__, "initDefaultSumoLogic", function () {
      return sumoLogic;
    }), __webpack_require__.d(__webpack_exports__, "initDefaultMixpanel", function () {
      return defaultimplementation_mixpanel;
    });
    var ecommerce_namespaceObject = {};
    __webpack_require__.r(ecommerce_namespaceObject), __webpack_require__.d(ecommerce_namespaceObject, "productView", function () {
      return productView;
    }), __webpack_require__.d(ecommerce_namespaceObject, "productDetailView", function () {
      return productDetailView;
    }), __webpack_require__.d(ecommerce_namespaceObject, "clickProductLink", function () {
      return clickProductLink;
    }), __webpack_require__.d(ecommerce_namespaceObject, "addToCart", function () {
      return addToCart;
    }), __webpack_require__.d(ecommerce_namespaceObject, "removeFromCart", function () {
      return removeFromCart;
    }), __webpack_require__.d(ecommerce_namespaceObject, "checkoutStepView", function () {
      return checkoutStepView;
    }), __webpack_require__.d(ecommerce_namespaceObject, "addCheckoutOption", function () {
      return addCheckoutOption;
    }), __webpack_require__.d(ecommerce_namespaceObject, "purchaseView", function () {
      return purchaseView;
    });
    var EventProvider = __webpack_require__("./EventProvider.js"),
      ecommerceTopics = {
        PRODUCT_VIEW: "JUTRO_ECOMMERCE_TOPICS.PRODUCT_VIEW",
        PRODUCT_LINK_CLICK: "JUTRO_ECOMMERCE_TOPICS.PRODUCT_LINK_CLICK",
        PRODUCT_DETAIL_VIEW: "JUTRO_ECOMMERCE_TOPICS.PRODUCT_DETAIL_VIEW",
        CART_ADD: "JUTRO_ECOMMERCE_TOPICS.CART_ADD",
        CART_REMOVE: "JUTRO_ECOMMERCE_TOPICS.CART_REMOVE",
        CHECKOUT_STEP_VIEW: "JUTRO_ECOMMERCE_TOPICS.CHECKOUT_STEP_VIEW",
        CHECKOUT_OPITION_ADD: "JUTRO_ECOMMERCE_TOPICS.CHECKOUT_OPITION_ADD",
        PURCHASE_VIEW: "JUTRO_ECOMMERCE_TOPICS.PURCHASE_VIEW"
      };
    function productView(productImpressions) {
      Object(EventProvider.b)(ecommerceTopics.PRODUCT_VIEW, {
        productImpressions: productImpressions
      });
    }
    function productDetailView(products) {
      Object(EventProvider.b)(ecommerceTopics.PRODUCT_DETAIL_VIEW, {
        products: products
      });
    }
    function clickProductLink(products, actionProps, eventProps) {
      Object(EventProvider.b)(ecommerceTopics.PRODUCT_LINK_CLICK, {
        products: products,
        actionProps: actionProps,
        eventProps: eventProps
      });
    }
    function addToCart(products, actionProps, eventProps) {
      Object(EventProvider.b)(ecommerceTopics.CART_ADD, {
        products: products,
        actionProps: actionProps,
        eventProps: eventProps
      });
    }
    function removeFromCart(products, actionProps, eventProps) {
      Object(EventProvider.b)(ecommerceTopics.CART_REMOVE, {
        products: products,
        actionProps: actionProps,
        eventProps: eventProps
      });
    }
    function checkoutStepView(products, actionProps) {
      Object(EventProvider.b)(ecommerceTopics.CHECKOUT_STEP_VIEW, {
        products: products,
        actionProps: actionProps
      });
    }
    function addCheckoutOption(products, actionProps, eventProps) {
      Object(EventProvider.b)(ecommerceTopics.CHECKOUT_OPITION_ADD, {
        products: products,
        actionProps: actionProps,
        eventProps: eventProps
      });
    }
    function purchaseView(products, actionProps) {
      Object(EventProvider.b)(ecommerceTopics.PURCHASE_VIEW, {
        products: products,
        actionProps: actionProps
      });
    }
    var for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
      for_each_default = __webpack_require__.n(for_each_),
      external_lodash_ = __webpack_require__("lodash"),
      external_lodash_default = __webpack_require__.n(external_lodash_),
      logger_ = (__webpack_require__("core-js/modules/web.dom-collections.iterator"), __webpack_require__("@jutro/logger"));
    function loadGA(trackingId) {
      if (!trackingId) return Object(logger_.warning)("To enable GA provide tracking id"), null;
      var ga = function (options) {
        var gaAddress = "https://www.google-analytics.com/analytics.js";
        var i, s, o, g, r, a, m;
        return i = window, s = document, o = "script", g = gaAddress, r = "ga", i.GoogleAnalyticsObject = r, i.ga = i.ga || function () {
          (i.ga.q = i.ga.q || []).push(arguments);
        }, i.ga.l = 1 * new Date(), a = s.createElement(o), m = s.getElementsByTagName(o)[0], a.async = 1, a.src = g, m.parentNode.insertBefore(a, m), i.ga, function () {
          var _window;
          return (_window = window).ga.apply(_window, arguments);
        };
      }();
      return ga("create", trackingId, "auto"), ga;
    }
    function toList(items) {
      return external_lodash_default.a.isArray(items) ? items : [items];
    }
    function initializeEnhancedEcommerce(gaOrTrackingId) {
      var ga = external_lodash_default.a.isFunction(gaOrTrackingId) ? gaOrTrackingId : loadGA(gaOrTrackingId);
      function sendCheckoutOptionAdd(_ref) {
        var actionProps = _ref.actionProps,
          eventProps = _ref.eventProps,
          hitCallback = _ref.hitCallback;
        ga("ec:setAction", "checkout_option", actionProps), ga("send", {
          hitType: "event",
          eventCategory: (null == eventProps ? void 0 : eventProps.eventCategory) || "Checkout",
          eventAction: (null == eventProps ? void 0 : eventProps.eventAction) || "Option",
          eventLabel: null == eventProps ? void 0 : eventProps.eventLabel
        }, {
          hitCallback: hitCallback
        });
      }
      ga("require", "ec"), Object(EventProvider.c)(ecommerceTopics.PRODUCT_VIEW, function (_ref2) {
        var productImpressions = _ref2.productImpressions;
        return products = productImpressions, for_each_default()(_context = toList(products)).call(_context, function (impression) {
          return ga("ec:addImpression", impression);
        }), void ga("send", "pageview");
        var products, _context;
      }), Object(EventProvider.c)(ecommerceTopics.PRODUCT_LINK_CLICK, function (_ref3) {
        var products = _ref3.products,
          actionProps = _ref3.actionProps,
          eventProps = _ref3.eventProps;
        return function (_ref4) {
          var product = _ref4.product,
            actionProps = _ref4.actionProps,
            eventProps = _ref4.eventProps,
            hitCallback = _ref4.hitCallback;
          ga("ec:addProduct", product), ga("ec:setAction", "click", actionProps), ga("send", {
            hitType: "event",
            eventCategory: (null == eventProps ? void 0 : eventProps.eventCategory) || "EC",
            eventAction: (null == eventProps ? void 0 : eventProps.eventAction) || "click",
            eventLabel: null == eventProps ? void 0 : eventProps.eventLabel
          }, {
            hitCallback: hitCallback
          });
        }({
          products: products,
          actionProps: actionProps,
          eventProps: eventProps
        });
      }), Object(EventProvider.c)(ecommerceTopics.PRODUCT_DETAIL_VIEW, function (_ref5) {
        var products = _ref5.products;
        return function (_ref6) {
          var product = _ref6.product;
          ga("ec:addProduct", product), ga("ec:setAction", "detail"), ga("send", "pageview");
        }({
          products: products
        });
      }), Object(EventProvider.c)(ecommerceTopics.CART_ADD, function (_ref7) {
        var products = _ref7.products,
          actionProps = _ref7.actionProps,
          eventProps = _ref7.eventProps;
        return function (_ref8) {
          var products = _ref8.products,
            actionProps = _ref8.actionProps,
            eventProps = _ref8.eventProps,
            hitCallback = _ref8.hitCallback;
          var productsList = toList(products);
          for_each_default()(productsList).call(productsList, function (product) {
            return ga("ec:addProduct", product);
          }), ga("ec:setAction", "add", actionProps), ga("send", {
            hitType: "event",
            eventCategory: (null == eventProps ? void 0 : eventProps.eventCategory) || "EC",
            eventAction: (null == eventProps ? void 0 : eventProps.eventAction) || "click",
            eventLabel: null == eventProps ? void 0 : eventProps.eventLabel
          }, {
            hitCallback: hitCallback
          });
        }({
          products: products,
          actionProps: actionProps,
          eventProps: eventProps
        });
      }), Object(EventProvider.c)(ecommerceTopics.CART_REMOVE, function (_ref9) {
        var products = _ref9.products,
          actionProps = _ref9.actionProps,
          eventProps = _ref9.eventProps;
        return function (_ref0) {
          var products = _ref0.products,
            actionProps = _ref0.actionProps,
            eventProps = _ref0.eventProps,
            hitCallback = _ref0.hitCallback;
          var productsList = toList(products);
          for_each_default()(productsList).call(productsList, function (product) {
            return ga("ec:addProduct", product);
          }), ga("ec:setAction", "remove", actionProps), ga("send", {
            hitType: "event",
            eventCategory: (null == eventProps ? void 0 : eventProps.eventCategory) || "EC",
            eventAction: (null == eventProps ? void 0 : eventProps.eventAction) || "click",
            eventLabel: null == eventProps ? void 0 : eventProps.eventLabel
          }, {
            hitCallback: hitCallback
          });
        }({
          products: products,
          actionProps: actionProps,
          eventProps: eventProps
        });
      }), Object(EventProvider.c)(ecommerceTopics.CHECKOUT_STEP_VIEW, function (_ref1) {
        var products = _ref1.products,
          actionProps = _ref1.actionProps;
        return function (_ref10) {
          var products = _ref10.products,
            actionProps = _ref10.actionProps;
          var productsList = toList(products);
          for_each_default()(productsList).call(productsList, function (product) {
            return ga("ec:addProduct", product);
          }), ga("ec:setAction", "checkout", actionProps), ga("send", "pageview");
        }({
          products: products,
          actionProps: actionProps
        });
      }), Object(EventProvider.c)(ecommerceTopics.CHECKOUT_OPITION_ADD, function (_ref11) {
        var products = _ref11.products,
          actionProps = _ref11.actionProps,
          eventProps = _ref11.eventProps;
        return sendCheckoutOptionAdd({
          products: products,
          actionProps: actionProps,
          eventProps: eventProps
        });
      }), Object(EventProvider.c)(ecommerceTopics.CHECKOUT_OPITION_ADD, function (_ref12) {
        var products = _ref12.products,
          actionProps = _ref12.actionProps,
          eventProps = _ref12.eventProps;
        return sendCheckoutOptionAdd({
          products: products,
          actionProps: actionProps,
          eventProps: eventProps
        });
      }), Object(EventProvider.c)(ecommerceTopics.PURCHASE_VIEW, function (_ref13) {
        var products = _ref13.products,
          actionProps = _ref13.actionProps;
        return function (_ref14) {
          var products = _ref14.products,
            actionProps = _ref14.actionProps;
          var productsList = toList(products);
          for_each_default()(productsList).call(productsList, function (product) {
            return ga("ec:addProduct", product);
          }), ga("ec:setAction", "purchase", actionProps), ga("send", "pageview");
        }({
          products: products,
          actionProps: actionProps
        });
      });
    }
    var jutroTopics = {
        COMPONENT_LOADED: "JUTRO_TOPICS.COMPONENT_LOADED",
        VALUE_CHANGED: "JUTRO_TOPICS.VALUE_CHANGED",
        FIELD_BLUR: "JUTRO_TOPICS.FIELD_BLUR",
        ROUTE_CHANGED: "JUTRO_TOPICS.ROUTE_CHANGED",
        FETCH_REQUEST: "JUTRO_TOPICS.FETCH_REQUEST",
        FETCH_RESPONSE: "JUTRO_TOPICS.FETCH_RESPONSE",
        FETCH_ERROR: "JUTRO_TOPICS.FETCH_ERROR",
        UNKNOWN_ERROR: "JUTRO_TOPICS.UNKNOWN_ERROR",
        BUTTON_CLICKED: "JUTRO_TOPICS.BUTTON_CLICKED",
        LINK_CLICKED: "JUTRO_TOPICS.LINK_CLICKED"
      },
      slice_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/slice"),
      slice_default = __webpack_require__.n(slice_),
      concat_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/concat"),
      concat_default = __webpack_require__.n(concat_);
    function loadMixpanel(trackingId) {
      return trackingId ? (function (e, a) {
        if (!a.__SV) {
          var k,
            h,
            b = window;
          try {
            var c,
              l,
              i,
              j = b.location,
              g = j.hash;
            c = function c(a, b) {
              return (l = a.match(RegExp(b + "=([^&]*)"))) ? l[1] : null;
            }, g && c(g, "state") && "mpeditor" === (i = JSON.parse(decodeURIComponent(c(g, "state")))).action && (b.sessionStorage.setItem("_mpcehash", g), history.replaceState(i.desiredHash || "", e.title, j.pathname + j.search));
          } catch (m) {}
          window.mixpanel = a, a._i = [], a.init = function (b, c, f) {
            function e(b, a) {
              var c = a.split(".");
              2 == c.length && (b = b[c[0]], a = c[1]), b[a] = function () {
                var _context;
                b.push(concat_default()(_context = [a]).call(_context, slice_default()(Array.prototype).call(arguments, 0)));
              };
            }
            var d = a;
            for (void 0 !== f ? d = a[f] = [] : f = "mixpanel", d.people = d.people || [], d.toString = function (b) {
              var a = "mixpanel";
              return "mixpanel" !== f && (a += "." + f), b || (a += " (stub)"), a;
            }, d.people.toString = function () {
              return d.toString(1) + ".people (stub)";
            }, k = "disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" "), h = 0; h < k.length; h++) e(d, k[h]);
            a._i.push([b, c, f]);
          }, a.__SV = 1.2, (b = e.createElement("script")).type = "text/javascript", b.async = !0, b.src = "undefined" != typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === e.location.protocol && "//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js", (c = e.getElementsByTagName("script")[0]).parentNode.insertBefore(b, c);
        }
      }(document, window.mixpanel || []), window.mixpanel.init(trackingId), window.mixpanel) : (Object(logger_.warning)("To enable Mixpanel provide tracking id"), null);
    }
    var SumoLogger = __webpack_require__("sumo-logger");
    function loadSumoLogic(sumoLogicUrl, sourceName, sourceCategory) {
      var opts = {
        endpoint: sumoLogicUrl,
        returnPromise: !1,
        sendErrors: !0,
        sourceName: sourceName,
        sourceCategory: sourceCategory,
        hostName: window.location.hostname,
        onSuccess: function onSuccess() {
          Object(logger_.info)("Sumo logic success");
        },
        onError: function onError() {
          Object(logger_.error)("Sumo logic failed");
        }
      };
      return new SumoLogger(opts);
    }
    var keys_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/keys"),
      keys_default = __webpack_require__.n(keys_),
      reduce_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/reduce"),
      reduce_default = __webpack_require__.n(reduce_),
      DictionaryProvider = {
        create: function create(config) {
          return function (event) {
            var _context;
            return reduce_default()(_context = keys_default()(event)).call(_context, function (result, key) {
              var _config$eventKeys;
              return (null == config || null === (_config$eventKeys = config.eventKeys) || void 0 === _config$eventKeys ? void 0 : _config$eventKeys[key]) ? (result[key] = config.eventKeys[key], result) : (result[key] = event[key], result);
            }, {});
          };
        }
      },
      index_of_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/index-of"),
      index_of_default = __webpack_require__.n(index_of_),
      WhitelistProvider = {
        create: function create(config) {
          return function (event) {
            var _context;
            return reduce_default()(_context = keys_default()(event)).call(_context, function (result, key) {
              var _context2;
              return (null == config ? void 0 : config.allowedProperties) && -1 !== index_of_default()(_context2 = config.allowedProperties).call(_context2, key) ? (result[key] = event[key], result) : (result[key] = config.obfuscationString, result);
            }, {});
          };
        }
      },
      stringify_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/json/stringify"),
      stringify_default = __webpack_require__.n(stringify_),
      config_ = __webpack_require__("@jutro/config"),
      defaultimplementation_ga = function defaultimplementation_ga() {
        var trackingConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          whitelistConfig: {},
          dictionaryConfig: {}
        };
        var ga = loadGA(Object(config_.getConfigValue)("GA_TRACKING_ID"));
        ga("send", "pageview"), Object(EventProvider.c)(jutroTopics.UNKNOWN_ERROR, function (event) {
          return ga("send", {
            hitType: "event",
            eventCategory: event.error,
            eventAction: jutroTopics.UNKNOWN_ERROR,
            eventLabel: stringify_default()(event)
          });
        }), Object(EventProvider.c)([jutroTopics.VALUE_CHANGED, jutroTopics.FIELD_BLUR], function (event, topic) {
          var _trackingConfig$dicti, _trackingConfig$dicti2;
          return ga("send", {
            hitType: "event",
            eventCategory: null === (_trackingConfig$dicti = trackingConfig.dictionaryConfig) || void 0 === _trackingConfig$dicti || null === (_trackingConfig$dicti2 = _trackingConfig$dicti.eventKeys) || void 0 === _trackingConfig$dicti2 ? void 0 : _trackingConfig$dicti2.path,
            eventAction: topic,
            eventLabel: event.path
          });
        }), Object(EventProvider.c)([jutroTopics.BUTTON_CLICKED, jutroTopics.LINK_CLICKED], function (event, topic) {
          return ga("send", {
            hitType: "event",
            eventAction: topic,
            eventCategory: event.label,
            eventLabel: stringify_default()(event)
          });
        }), Object(EventProvider.c)([jutroTopics.ROUTE_CHANGED], function (event, topic) {
          ga("send", topic, {
            hitType: "event",
            eventAction: topic,
            eventCategory: event.eventCategory,
            eventLabel: event.pathname
          });
        }), Object(EventProvider.c)([jutroTopics.FETCH_REQUEST, jutroTopics.FETCH_RESPONSE, jutroTopics.FETCH_ERROR], function (event, topic) {
          ga("send", topic, {
            hitType: "event",
            eventAction: topic,
            eventCategory: event.eventCategory,
            eventLabel: event.url
          });
        });
        var whitelist = WhitelistProvider.create(trackingConfig.whitelistConfig),
          translate = DictionaryProvider.create(trackingConfig.dictionaryConfig);
        Object(EventProvider.c)(jutroTopics.COMPONENT_LOADED, function (event, topic) {
          var transformedEvent = translate(whitelist(event));
          ga("send", {
            hitType: "event",
            eventCategory: "Props",
            eventAction: topic,
            eventLabel: stringify_default()(transformedEvent)
          });
        });
      },
      sumoLogic = function sumoLogic() {
        var sumoLogicUrl = Object(config_.getConfigValue)("sumoLogicUrl"),
          sumoLogicSourceName = Object(config_.getConfigValue)("sumoLogicSourceName") || "Jutro App";
        if (!sumoLogicUrl) return;
        var defaultLogger = loadSumoLogic(sumoLogicUrl, sumoLogicSourceName, "fetch"),
          errorLogger = loadSumoLogic(sumoLogicUrl, sumoLogicSourceName, "error"),
          UNKNOWN_ERROR = jutroTopics.UNKNOWN_ERROR,
          FETCH_ERROR = jutroTopics.FETCH_ERROR,
          FETCH_REQUEST = jutroTopics.FETCH_REQUEST,
          FETCH_RESPONSE = jutroTopics.FETCH_RESPONSE;
        Object(EventProvider.c)([UNKNOWN_ERROR, FETCH_ERROR], function (event, topic) {
          errorLogger.log(stringify_default()(event), {
            sourceCategory: topic
          });
        }), Object(EventProvider.c)([FETCH_REQUEST, FETCH_RESPONSE], function (event, topic) {
          defaultLogger.log(stringify_default()(event), {
            sourceCategory: topic
          });
        });
      },
      objectWithoutProperties = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/objectWithoutProperties.js"),
      objectWithoutProperties_default = __webpack_require__.n(objectWithoutProperties),
      defaultimplementation_mixpanel = function defaultimplementation_mixpanel() {
        var trackingConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          whitelistConfig: {},
          dictionaryConfig: {}
        };
        var mixpanel = loadMixpanel(Object(config_.getConfigValue)("MIXPANEL_TRACKING_ID")),
          whitelist = WhitelistProvider.create(trackingConfig.whitelistConfig),
          translate = DictionaryProvider.create(trackingConfig.dictionaryConfig),
          UNKNOWN_ERROR = jutroTopics.UNKNOWN_ERROR,
          REST_JUTRO_TOPICS = objectWithoutProperties_default()(jutroTopics, ["UNKNOWN_ERROR"]);
        Object(EventProvider.c)(UNKNOWN_ERROR, function (event) {
          return mixpanel.track(UNKNOWN_ERROR, event.error);
        }), Object(EventProvider.c)(REST_JUTRO_TOPICS, function (event, topic) {
          var transformedEvent = translate(whitelist(event));
          mixpanel.track(topic, transformedEvent);
        });
      };
    var ecommerce = ecommerce_namespaceObject;
  },
  "@babel/runtime-corejs3/core-js-stable/instance/concat": function babel_runtimeCorejs3_coreJsStable_instance_concat(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/concat");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/every": function babel_runtimeCorejs3_coreJsStable_instance_every(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/every");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babel_runtimeCorejs3_coreJsStable_instance_forEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/index-of": function babel_runtimeCorejs3_coreJsStable_instance_indexOf(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/index-of");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/map": function babel_runtimeCorejs3_coreJsStable_instance_map(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/map");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/reduce": function babel_runtimeCorejs3_coreJsStable_instance_reduce(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/slice": function babel_runtimeCorejs3_coreJsStable_instance_slice(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/slice");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/values": function babel_runtimeCorejs3_coreJsStable_instance_values(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/values");
  },
  "@babel/runtime-corejs3/core-js-stable/json/stringify": function babel_runtimeCorejs3_coreJsStable_json_stringify(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/json/stringify");
  },
  "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols": function babel_runtimeCorejs3_coreJsStable_object_getOwnPropertySymbols(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
  },
  "@babel/runtime-corejs3/core-js-stable/object/keys": function babel_runtimeCorejs3_coreJsStable_object_keys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/symbol/for": function babel_runtimeCorejs3_coreJsStable_symbol_for(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/symbol/for");
  },
  "@jutro/config": function jutro_config(module, exports) {
    module.exports = require("@jutro/config");
  },
  "@jutro/logger": function jutro_logger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "core-js-pure/features/instance/index-of": function coreJsPure_features_instance_indexOf(module, exports) {
    module.exports = require("core-js-pure/features/instance/index-of");
  },
  "core-js-pure/features/object/define-property": function coreJsPure_features_object_defineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  "core-js-pure/features/object/get-own-property-symbols": function coreJsPure_features_object_getOwnPropertySymbols(module, exports) {
    module.exports = require("core-js-pure/features/object/get-own-property-symbols");
  },
  "core-js-pure/features/object/keys": function coreJsPure_features_object_keys(module, exports) {
    module.exports = require("core-js-pure/features/object/keys");
  },
  "core-js/modules/web.dom-collections.iterator": function coreJs_modules_webDomCollectionsIterator(module, exports) {
    module.exports = require("core-js/modules/web.dom-collections.iterator");
  },
  events: function events(module, exports) {
    module.exports = require("events");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  },
  "sumo-logger": function sumoLogger(module, exports) {
    module.exports = require("sumo-logger");
  }
});